import * as React from "react";

const SvgLightRain = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightRain_svg__a">
        <path d="M0 943.388h1828.656V0H0Z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightRain_svg__b">
        <path d="M315.904 707.602c-.052 0-.104.003-.157.003a8.288 8.288 0 0 1 0-16.575h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.309" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightRain_svg__c">
        <path d="m286.924 682.682-2.888-4.999a2 2 0 0 1 .733-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2.001 2.001 0 0 1-.733 2.732 1.997 1.997 0 0 1-2.732-.733" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightRain_svg__d">
        <path d="m303.035 682.682-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2.001 2.001 0 0 1-.732 2.732 2 2 0 0 1-2.733-.733" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightRain_svg__e">
        <path d="m319.147 682.682-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 2 2 0 0 1-1.733-1.002" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightRain_svg__f">
        <path d="m291.923 675.503-2.886-5a2 2 0 0 1 .732-2.732 2.002 2.002 0 0 1 2.733.732l2.886 5a2 2 0 0 1-.733 2.732 1.999 1.999 0 0 1-2.732-.732" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightRain_svg__g">
        <path d="m308.536 675.503-2.887-5a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.886 5a2 2 0 0 1-.731 2.732 1.997 1.997 0 0 1-2.733-.732" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightRain_svg__h">
        <path d="m325.147 675.503-2.887-5a2.001 2.001 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#LightRain_svg__a)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M0 0c5.889 0 10.664 4.774 10.664 10.664 0 5.889-4.775 10.664-10.664 10.664-.037 0-.072-.006-.109-.006-.949 8.504-8.158 15.116-16.915 15.116-6.915 0-12.864-4.125-15.528-10.048-.085.002-.168.006-.253.006-7.289 0-13.198-5.909-13.198-13.198C-46.003 5.909-40.094 0-32.805 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          transform="translate(322.129 691.03)"
        />
      </g>
    </g>
    <g
      clipPath="url(#LightRain_svg__b)"
      style={{
        fill: "#ddedf9",
        fillOpacity: 1,
      }}
      transform="matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
    >
      <g
        style={{
          fill: "#ddedf9",
          fillOpacity: 1,
        }}
      >
        <path
          d="M315.904 707.602c-.052 0-.104.003-.157.003a8.288 8.288 0 0 1 0-16.575h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.342 0-8.078-2.591-9.752-6.309"
          style={{
            fill: "#ddedf9",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightRain_svg__c)"
      style={{
        fill: "#00b6f1",
        fillOpacity: 1,
      }}
      transform="matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
    >
      <g
        style={{
          fill: "#00b6f1",
          fillOpacity: 1,
        }}
      >
        <path
          d="m286.924 682.682-2.888-4.999a2 2 0 0 1 .733-2.732 1.999 1.999 0 0 1 2.732.732l2.888 5a2.001 2.001 0 0 1-.733 2.732 1.997 1.997 0 0 1-2.732-.733"
          style={{
            fill: "#00b6f1",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightRain_svg__d)"
      style={{
        fill: "#00b6f1",
        fillOpacity: 1,
      }}
      transform="matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
    >
      <g
        style={{
          fill: "#00b6f1",
          fillOpacity: 1,
        }}
      >
        <path
          d="m303.035 682.682-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2.001 2.001 0 0 1-.732 2.732 2 2 0 0 1-2.733-.733"
          style={{
            fill: "#00b6f1",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightRain_svg__e)"
      style={{
        fill: "#00b6f1",
        fillOpacity: 1,
      }}
      transform="matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
    >
      <g
        style={{
          fill: "#00b6f1",
          fillOpacity: 1,
        }}
      >
        <path
          d="m319.147 682.682-2.887-4.999a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 2 2 0 0 1-1.733-1.002"
          style={{
            fill: "#00b6f1",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightRain_svg__f)"
      style={{
        fill: "#00b6f1",
        fillOpacity: 1,
      }}
      transform="matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
    >
      <g
        style={{
          fill: "#00b6f1",
          fillOpacity: 1,
        }}
      >
        <path
          d="m291.923 675.503-2.886-5a2 2 0 0 1 .732-2.732 2.002 2.002 0 0 1 2.733.732l2.886 5a2 2 0 0 1-.733 2.732 1.999 1.999 0 0 1-2.732-.732"
          style={{
            fill: "#00b6f1",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightRain_svg__g)"
      style={{
        fill: "#00b6f1",
        fillOpacity: 1,
      }}
      transform="matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
    >
      <g
        style={{
          fill: "#00b6f1",
          fillOpacity: 1,
        }}
      >
        <path
          d="m308.536 675.503-2.887-5a2 2 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.886 5a2 2 0 0 1-.731 2.732 1.997 1.997 0 0 1-2.733-.732"
          style={{
            fill: "#00b6f1",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightRain_svg__h)"
      style={{
        fill: "#00b9f1",
        fillOpacity: 1,
      }}
      transform="matrix(1.43463 0 0 -1.43463 -396.137 1048.63)"
    >
      <g
        style={{
          fill: "#00b9f1",
          fillOpacity: 1,
        }}
      >
        <path
          d="m325.147 675.503-2.887-5a2.001 2.001 0 0 1 .733-2.732 2 2 0 0 1 2.732.732l2.887 5a2 2 0 0 1-1.732 3.001 1.999 1.999 0 0 1-1.733-1.001"
          style={{
            fill: "#00b9f1",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        stroke: "none",
        strokeWidth: 0.883715,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 -672.135 1257.58)"
      d="M504.101-943.185h72v72h-72z"
    />
  </svg>
);

export default SvgLightRain;
